import React from 'react'

import { bool, func, number, oneOf, shape, string } from 'prop-types'

import { NOOP } from 'Utils/stableDefaults'

import PlanCard from './Components/PlanCard'
import UsageTracker from './Components/UsageTracker'
import { PLAN_TYPE, SUBSCRIPTION_STATUS, TIER } from '../../constants'

function Subscription({
  subscription,
  locale = 'en',
  isUsageDisabled = false,
  isCancelLoading = false,
  onCancel: handleCancelSubscription = NOOP,
  onReactivate: handleReactivateSubscription = NOOP,
  onRenew: handleRenewSubscription = NOOP,
  isRestoreLoading = false,
  updatePaymentUrl = '/profile/subscription/update-payment-method',
  onRetryPayment: handleRetryPayment = NOOP,
  retryState = 'idle',
  onSwitchPlan: handleSwitchPlan = NOOP,
  subscriptionV16Enabled = false,
  onCancelPlanSwitch: handleCancelPlanSwitch = NOOP,
  isCancelPlanSwitchLoading = false,
  onResumePause: handleResumePause = NOOP,
  isResumeLoading = false,
  resumeRequested = false,
}) {

  const {
    status,
    statusLabel,
    tier,
    canceledAt,
    canceledByAdmin,
    price,
    renewsOn,
    paymentMethod,
    periodEndDate,
    downloadsUsed,
    downloadLimit,
    subscriptionEndDate,
    planType,
    billingCycle,
    scheduledPlanSwitchTo,
    scheduledPlanSwitchAt,
    userPauseScheduledAt,
    userPause,
    pausedUntil,
  } = subscription

  return (
    <div className="subscription">
      <div className="subscription__container">
        <PlanCard
          status={status}
          statusLabel={statusLabel}
          tier={tier}
          canceledAt={canceledAt}
          canceledByAdmin={canceledByAdmin}
          price={price}
          renewsOn={renewsOn}
          paymentMethod={paymentMethod}
          subscriptionEndDate={subscriptionEndDate}
          onCancel={handleCancelSubscription}
          isCancelLoading={isCancelLoading}
          onReactivate={handleReactivateSubscription}
          onRenew={handleRenewSubscription}
          isRestoreLoading={isRestoreLoading}
          locale={locale}
          updatePaymentUrl={updatePaymentUrl}
          onRetryPayment={handleRetryPayment}
          retryState={retryState}
          planType={planType}
          billingCycle={billingCycle}
          onSwitchPlan={handleSwitchPlan}
          subscriptionV16Enabled={subscriptionV16Enabled}
          scheduledPlanSwitchTo={scheduledPlanSwitchTo}
          scheduledPlanSwitchAt={scheduledPlanSwitchAt}
          onCancelPlanSwitch={handleCancelPlanSwitch}
          isCancelPlanSwitchLoading={isCancelPlanSwitchLoading}
          userPauseScheduledAt={userPauseScheduledAt}
          userPause={userPause}
          pausedUntil={pausedUntil}
          onResumePause={handleResumePause}
          isResumeLoading={isResumeLoading}
          resumeRequested={resumeRequested}
        />
        <aside className="subscription__aside">
          <UsageTracker
            downloadsUsed={downloadsUsed}
            downloadLimit={downloadLimit}
            periodEndDate={periodEndDate}
            canceledByAdmin={canceledByAdmin}
            isDisabled={isUsageDisabled}
            isPaused={status === SUBSCRIPTION_STATUS.PAUSED}
            locale={locale}
          />
        </aside>
      </div>
    </div>
  )
}

Subscription.propTypes = {
  subscription: shape({
    id: number,
    status: string.isRequired,
    statusLabel: string.isRequired,
    tier: oneOf([TIER.ESSENTIALS, TIER.PREMIUM]),
    canceledAt: string,
    canceledByAdmin: bool,
    price: string.isRequired,
    renewsOn: string,
    paymentMethod: string.isRequired,
    periodEndDate: string,
    downloadsUsed: number.isRequired,
    downloadLimit: number.isRequired,
    subscriptionEndDate: string,
    planType: oneOf([PLAN_TYPE.MONTHLY, PLAN_TYPE.YEARLY]),
    billingCycle: oneOf([PLAN_TYPE.MONTHLY, PLAN_TYPE.YEARLY]),
    scheduledPlanSwitchTo: string,
    scheduledPlanSwitchAt: string,
    userPauseScheduledAt: string,
    userPause: bool,
    pausedUntil: string,
  }).isRequired,
  locale: string,
  isUsageDisabled: bool,
  onCancel: func,
  isCancelLoading: bool,
  onReactivate: func,
  onRenew: func,
  isRestoreLoading: bool,
  updatePaymentUrl: string,
  onRetryPayment: func,
  retryState: string,
  onSwitchPlan: func,
  subscriptionV16Enabled: bool,
  onCancelPlanSwitch: func,
  isCancelPlanSwitchLoading: bool,
  onResumePause: func,
  isResumeLoading: bool,
  resumeRequested: bool,
}

export default Subscription
